<template>
  <div class="body">
    <el-row :gutter="40" style="margin: 0px; width: 100%" justify="center" type="flex">
      <el-col :md="$store.getters.isLoggedIn ? 8 : 7">
        <br />
        <br />
        <el-alert title="Información importante" type="info" show-icon>
          <template>
            <small>
              <p>Estimados Usuarios, les informamos que solo tendrán
                acceso al "Dashboard General" los usuarios que cuenten
                con una cuenta de acceso a nuestra plataforma.
                <br><br>
                En caso de que usted trabaje con los inventarios de riesgos y reportes del "Dashboard General" y no
                cuente con una cuenta de acceso, puede ponerse en contacto con el equipo de soporte.
                <br><br>
                +56 9 7499 5325 (Operativo) <br>
                +56 9 9022 5668 (Operativo) <br>
                support@safetyclub.zendesk.com <br><br>
                Horario atención telefónica y chat: Lunes a Viernes de 9:00 a 18:30
              </p>
            </small>
          </template>
        </el-alert>
        <br>
        <el-card shadow="always">
          <el-col :span="24">
            <h3 style="font-size: 13px; margin-top: 0px; margin-bottom: 6px">
              INSTRUCTIVOS PARA REVISIÓN
              <br />
            </h3>
            <br />
          </el-col>
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="info" size="small"
            icon="el-icon-tickets" @click="descargarInstructivo('mel')">INSTRUCTIVO
            REVISIÓN MEL</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="info" size="small"
            icon="el-icon-tickets" @click="descargarInstructivo('spence')">INSTRUCTIVO
            REVISIÓN BHP CHILE Y PAMPA NORTE</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="danger" size="small"
            icon="el-icon-tickets" @click="descargarManual()">MANUAL DE USUARIO
          </el-button>
        </el-card>
      </el-col>
      <el-col :md="7" v-if="!$store.getters.isLoggedIn">
        <br />
        <br />
        <el-card shadow="always">
          <div slot="header">
            <h3 style="font-size: 13px; margin-top: 0px; margin-bottom: 0px">
              INGRESO USUARIOS COMPAÑÍA
              <br />
            </h3>
          </div>
          <el-alert center v-bind:title="error" type="error" v-if="error" show-icon :closable="false"></el-alert>

          <el-form :model="credentials" status-icon :rules="rulesLogin" ref="formLogin">
            <el-form-item style="margin-bottom: 10px" prop="rut" label="Nombre de usuario">
              <el-input :placeholder="$t('Ingrese nombre de usuario')" v-model="credentials.rut"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="Contraseña">
              <el-input type="password" :placeholder="$t('Ingrese contraseña')" @keyup.native.enter="submit"
                v-model="credentials.password"></el-input>
            </el-form-item>
          </el-form>
          <center>
            <VueRecaptcha :sitekey="siteKey" v-if="!$store.getters.isLoggedIn" :load-recaptcha-script="true"
              @verify="handleSuccessP" @error="handleErrorP">
            </VueRecaptcha>
            <br>
            <el-button :disabled="goSessionP || credentials.rut === '' || credentials.password === ''"
              v-if="!$store.getters.isLoggedIn" @click="submit" size="medium" type="warning">INICIAR SESIÓN
            </el-button>
            <br /><br />
            <el-button icon="el-icon-info" size="small" @click="autocreation()" type="info">¿Necesita crear su cuenta?,
              Realícelo aquí</el-button>
            <br /><br />
            <a href="#" @click="recovery" style="color: black; font-size: 13px"><b>¿Ha olvidado su contraseña?</b></a>

          </center>
        </el-card>
        <br />
        <br />
      </el-col>
      <el-col :md="7" v-if="!$store.getters.isLoggedIn">
        <br />
        <br />
        <el-card shadow="always">
          <div slot="header">
            <el-row>
              <el-col :span="24">
                <h3 style="font-size: 13px; margin-top: 0px; margin-bottom: 0px">
                  INGRESO USUARIOS COLABORADORES
                  <br />
                </h3>
              </el-col>
            </el-row>
          </div>
          <el-alert center v-bind:title="error" type="error" v-if="error" show-icon :closable="false"></el-alert>

          <el-form v-if="!$store.getters.isLoggedIn" :model="credentials_contratista" status-icon
            :rules="rulesLoginContratista" ref="formLoginContratista">
            <el-form-item style="margin-bottom: 10px" prop="rut" label="Nombre de usuario">
              <el-input :placeholder="$t('Ingrese nombre de usuario')" v-model="credentials_contratista.rut"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="Contraseña">
              <el-input type="password" :placeholder="$t('Ingrese contraseña')" @keyup.native.enter="submitContratista"
                v-model="credentials_contratista.password"></el-input>
            </el-form-item>
          </el-form>
          <div v-else>
            <center>
              Iniciado como
              <b>{{ username }}</b>
            </center>
            <br />
          </div>
          <center>
            <VueRecaptcha :sitekey="siteKey" v-if="!$store.getters.isLoggedIn" :load-recaptcha-script="true"
              @verify="handleSuccessC" @error="handleErrorC">
            </VueRecaptcha>
            <br>
            <el-button
              :disabled="goSessionC || credentials_contratista.rut === '' || credentials_contratista.password === ''"
              @click="submitContratista" v-if="!$store.getters.isLoggedIn" size="medium" type="warning">INICIAR SESIÓN
            </el-button>
            <br /><br />
            <el-button icon="el-icon-info" size="small" @click="autocreation()" type="info">¿Necesita crear su cuenta?,
              Realícelo aquí</el-button>
            <br /><br />
            <a href="#" @click="recovery" style="color: black; font-size: 13px"><b>¿Ha olvidado su contraseña?</b></a>
          </center>
        </el-card>
        <br />
        <br />
      </el-col>
      <el-col :md="8" v-if="$store.getters.isLoggedIn">
        <br />
        <br />
        <el-card class="box-card" shadow="always">
          <div slot="header">
            <el-row>
              <el-col :span="16">
                <h3 style="font-size: 16px; margin-top: 10px; margin-bottom: 0px">
                  INVENTARIO DE RIESGOS
                  <br />
                </h3>
              </el-col>
              <el-col :span="8">
                <img style="float: right" src="../assets/BHP.png" width="90px" />
              </el-col>
            </el-row>
          </div>
          <br />
          <div>
            Has iniciado sesión como
            <b>{{ username }}</b>
            <br /><br />
            <small><i class="el-icon-info"></i> Para acceder a la plataforma
              Inventario de Riesgos HSE Online debe hacer click en el botón
              <b>IR A LA PLATAFORMA</b></small>
            <br /><br /><br />
            <el-button style="
                width: 50%;
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
              " v-if="$store.getters.isLoggedIn" @click="plataforma" size="medium" type="info">IR A PLATAFORMA
            </el-button>
            <el-button style="
                margin: 0px !important;
                width: 50%;
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
              " v-if="$store.getters.isLoggedIn" @click="signOut" size="medium" type="danger">CERRAR SESIÓN</el-button>
          </div>
        </el-card>
        <br />
        <br />
      </el-col>
    </el-row>

    <el-dialog title="Encuesta de percepción Plataforma Inventario de riesgos HSE online" width="29%"
      :close-on-click-modal="false" :visible.sync="dialogEncuesta">
      <p class="mensaje-encuesta">Estimad@ usuario

        Con el objetivo de cumplir con el proceso de mejora continua de la Compañía solicitamos a usted que pueda
        contestar una breve encuesta (9 preguntas).

        Gracias de antemano por sus valiosos comentarios.

        Saludos Cordiales

        Safety Club
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openWindow(encuesta)">Contestar encuesta</el-button>
        <el-button type="info" @click="dialogEncuesta = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <SupportFooter />
  </div>
</template>

<script>
import axios from "axios";
import SupportFooter from "@/components/SupportFooterDashboard.vue";
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: "SafetyLogin",
  data() {
    return {
      goSessionP: true,
      goSessionC: true,
      siteKey: "6LfIYvIhAAAAAE0oKhMczb-FpqdTMEjwfUUL2wTQ",
      ip: "",
      host: location.host,
      isLoading: false,
      credentials: {
        rut: "",
        password: "",
      },
      credentials_contratista: {
        rut: "",
        password: "",
      },
      error: "",
      rulesLogin: {
        password: [{ validator: this.validatePass, trigger: "blur" }],
        rut: [{ validator: this.validateRUT, trigger: "blur" }],
      },
      rulesLoginContratista: {
        password: [{ validator: this.validatePass, trigger: "blur" }],
        rut: [{ validator: this.validateRUTContratista, trigger: "blur" }],
      },
      dialogEncuesta: false,
      encuesta:
        "https://forms.office.com/r/T4U3TBNdcK",
    };
  },
  components: {
    SupportFooter,
    VueRecaptcha,
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
  },
  created() {
    this.getIP();
  },
  methods: {
    handleErrorP() {
      // Do some validation
    },
    handleSuccessP(response) {
      this.goSessionP = false;
    },
    handleErrorC() {
      // Do some validation
    },
    handleSuccessC(response) {
      this.goSessionC = false;
    },
    async getIP() {
      var response = await axios.get(`https://api.ipify.org?format=json`);
      this.ip = response.data.ip;
    },
    descargarManual() {
      window.location.href =
        "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/MAm-HSE-MAN-219%20Manual%20Plataforma%20de%20Inventario%20de%20Riesgos%20HSE%20firmado.pdf?inline=false";
    },
    descargarInstructivo(faena) {
      if (faena === "mel") {
        window.location.href =
          "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revision%20por%20tarea%20MEL_.pdf?inline=false";
      } else {
        window.location.href =
          "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revisi%C3%B3n%20por%20tarea%20Pampa%20Norte_.pdf?inline=false";
      }
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserAllContracts");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", null);
      await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
      this.$router.push({ name: "homePage" });
    },
    plataforma() {
      this.redirectLoggedUser();
    },
    validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu contraseña")));
      } else {
        callback();
      }
    },
    validateRUT(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu nombre de usuario")));
      } else {
        callback();
      }
    },
    validateRUTContratista(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu nombre de usuario")));
      } else {
        callback();
      }
    },
    async submit() {
      if (this.goSessionP === false) {
        this.isLoading = true;
        this.$refs.formLogin.validate(async (valid) => {
          if (valid) {
            this.credentials["ip"] = this.ip;
            const response = await this.$store.dispatch(
              "login",
              this.credentials
            );
            if (!response.success) {
              this.isLoading = false;
              this.$notify.info({
                title: "Lo sentimos",
                dangerouslyUseHTMLString: true,
                message: `
                <div style="text-align: left;">
                ${response.error}
                </div>
                `
              });
              return;
            }
            this.redirectLoggedUser();
          } else {
            this.isLoading = false;
          }
        });
      } else {
        this.$notify.info({
          title: "Información",
          message: "Para continuar debe completar Captcha",
        });
      }
    },
    async submitContratista() {
      if (this.goSessionC === false) {
        this.isLoading = true;
        this.$refs.formLoginContratista.validate(async (valid) => {
          if (valid) {
            this.credentials["ip"] = this.ip;
            const response = await this.$store.dispatch(
              "login",
              this.credentials_contratista
            );
            if (!response.success) {
              this.isLoading = false;
              this.$notify.info({
                title: "Información",
                message: response.error,
              });
              return;
            }
            this.redirectLoggedUser();
          } else {
            this.isLoading = false;
          }
        });
      } else {
        this.$notify.info({
          title: "Información",
          message: "Para continuar debe completar Captcha",
        });
      }
    },
    autocreation() {
      this.$router.push({ name: "autoCreacionStep0" });
    },
    recovery() {
      this.$router.push({ name: "recoveryPassword0" });
    },
    setGoogle() {
      // Setea usuario en Google Analytics
      this.$ga.set("admin", this.$store.getters.role.admin || false);
      this.$ga.set("account_type", this.$store.getters.role.role);
      this.$ga.set("account", this.credentials.rut);
      this.$ga.set(
        "account_name",
        `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`
      );
    },
    async redirectLoggedUser() {
      const haveAccess = await this.$store.dispatch("getRoles");
      if (haveAccess) {
        await this.$store.dispatch("setRole");
        this.setGoogle();
        this.$router.push({ name: "SelectRoles" });
      } else {
        this.$alert('Su tiempo de sesión fue finalizada por inactividad, vuelva ingresar a plataforma.', 'Información', {
          confirmButtonText: 'Aceptar',
          callback: async action => {
            // reset datos de otros roles
            await this.$store.dispatch("resetEmpresasFaena");
            await this.$store.dispatch("resetAreas");
            await this.$store.dispatch("resetContract");
            await this.$store.dispatch("resetUserAllContracts");
            await this.$store.dispatch("resetUserContractByRole");
            await this.$store.dispatch("latestState", null);
            await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
            this.$router.push({ name: "homePage" });
          }
        });
      }
    },
    openWindow(link) {
      window.open(link);
    },
  },
};
</script>

<style scoped>
.body {
  background: url("../assets/fondo-login.jpg");
  height: 100vh;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
}

.box-card {
  width: 100%;
  margin: 0 auto;
  min-height: 360px;
}

.login {
  /*position: absolute;*/
  padding: 50px 50px 40px 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  max-width: 400px;
  /*top: 40px;
  left: 60px;*/
  /*box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.75);*/
  border: 2px solid #ccc;

  margin: 0 auto;
  margin-top: 80px;
}

.title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.logo-bhp {
  max-width: 100%;
}

.box-card {
  height: 420px !important;
}

.logo-escondida {
  max-width: 100%;
}

.el-alert {
  margin-bottom: 10px;
}

.button {
  width: 100%;
}

@media (max-width: 768px) {
  .login {
    border: none;
    margin-top: 40px;
    margin-right: 10px;
    margin-left: 10px;
    position: static;
    padding: 30px 30px 20px 30px;
  }
}

.mensaje-encuesta {
  white-space: pre-line;
  font-size: 16px;
  padding: 0;
}
</style>
